import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'dojo-submission-bar',
  template: `
    <div class="flex h-2 gap-px overflow-hidden rounded-full bg-neutral-100">
      @if (onTimePercent() > 0) {
        <div class="h-full min-w-0 bg-green-400" [style.width.%]="onTimePercent()"></div>
      }
      @if (latePercent() > 0) {
        <div class="h-full min-w-0 bg-amber-300" [style.width.%]="latePercent()"></div>
      }
      @if (missingPercent() > 0) {
        <div class="h-full min-w-0 bg-red-400" [style.width.%]="missingPercent()"></div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block w-full' },
})
export class SubmissionBarComponent {
  readonly onTimePercent = input.required<number>();
  readonly latePercent = input.required<number>();
  readonly missingPercent = input.required<number>();
}
